var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- components/bill-list/component--><h3 v-if=\"number\">Список выставленных счетов для контейнера № {{ number }}</h3><table v-on=\"click: onClick\" v-if=\"table\" class=\"custom_table\"><thead><tr><th>Счет / Дата</th><th>Сумма</th><th>Комментарии</th></tr></thead><tfoot><tr><th v-show=\"!table.length\" colspan=\"3\">Нет счетов</th></tr></tfoot><tbody><tr v-repeat=\"table\"><td><nobr>Счет № {{{* number | parseBillLink date }}}</nobr> <nobr>от&nbsp;{{* date | parseTime 'full' ' ' }}</nobr></td><td>{{* summa }}&nbsp;{{* currency }}</td><td>{{{* comment | parseCntLinks }}}</td></tr></tbody></table><component is=\"alert\" name=\"bill-list\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/bill-list/component.jade
 ** module id = 38
 ** module chunks = 0
 **/